var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17_21902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 58.8125C30.6225 58.8125 22.1875 50.3775 22.1875 40C22.1875 29.6225 30.6225 21.1875 41 21.1875C51.3775 21.1875 59.8125 29.6225 59.8125 40C59.8125 50.3775 51.3775 58.8125 41 58.8125ZM41 23.8125C32.075 23.8125 24.8125 31.075 24.8125 40C24.8125 48.925 32.075 56.1875 41 56.1875C49.925 56.1875 57.1875 48.925 57.1875 40C57.1875 31.075 49.925 23.8125 41 23.8125Z",
    fill: "url(#paint0_linear_17_21902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7499 57.0625H33.9999C33.2824 57.0625 32.6874 56.4675 32.6874 55.75C32.6874 55.0325 33.2474 54.455 33.9649 54.4375C31.2174 45.0575 31.2174 34.9425 33.9649 25.5625C33.2474 25.545 32.6874 24.9675 32.6874 24.25C32.6874 23.5325 33.2824 22.9375 33.9999 22.9375H35.7499C36.1699 22.9375 36.5724 23.1475 36.8174 23.48C37.0624 23.83 37.1324 24.2675 36.9924 24.67C33.7024 34.5575 33.7024 45.4425 36.9924 55.3475C37.1324 55.75 37.0624 56.1875 36.8174 56.5375C36.5724 56.8525 36.1699 57.0625 35.7499 57.0625Z",
    fill: "url(#paint1_linear_17_21902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2502 57.0624C46.1102 57.0624 45.9702 57.0449 45.8302 56.9924C45.1477 56.7649 44.7627 56.0124 45.0077 55.3299C48.2977 45.4424 48.2977 34.5574 45.0077 24.6524C44.7802 23.9699 45.1477 23.2174 45.8302 22.9899C46.5302 22.7624 47.2652 23.1299 47.4927 23.8124C50.9752 34.2424 50.9752 45.7224 47.4927 56.1349C47.3177 56.7124 46.7927 57.0624 46.2502 57.0624Z",
    fill: "url(#paint2_linear_17_21902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 49.0999C36.1175 49.0999 31.2525 48.4174 26.5625 47.0349C26.545 47.7349 25.9675 48.3124 25.25 48.3124C24.5325 48.3124 23.9375 47.7174 23.9375 46.9999V45.2499C23.9375 44.8299 24.1475 44.4274 24.48 44.1824C24.83 43.9374 25.2675 43.8674 25.67 44.0074C35.5575 47.2974 46.46 47.2974 56.3475 44.0074C56.75 43.8674 57.1875 43.9374 57.5375 44.1824C57.8875 44.4274 58.08 44.8299 58.08 45.2499V46.9999C58.08 47.7174 57.485 48.3124 56.7675 48.3124C56.05 48.3124 55.4725 47.7524 55.455 47.0349C50.7475 48.4174 45.8825 49.0999 41 49.0999Z",
    fill: "url(#paint3_linear_17_21902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7501 36.0624C56.6101 36.0624 56.4701 36.0449 56.3301 35.9924C46.4426 32.7024 35.5401 32.7024 25.6526 35.9924C24.9526 36.2199 24.2176 35.8524 23.9901 35.1699C23.7801 34.4699 24.1476 33.7349 24.8301 33.5074C35.2601 30.0249 46.7401 30.0249 57.1526 33.5074C57.8351 33.7349 58.2201 34.4874 57.9751 35.1699C57.8176 35.7124 57.2926 36.0624 56.7501 36.0624Z",
    fill: "url(#paint4_linear_17_21902)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17_21902",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_21902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_21902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_21902",
    x1: 41,
    y1: 21.1875,
    x2: 41,
    y2: 58.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_21902",
    x1: 34.484,
    y1: 22.9375,
    x2: 34.484,
    y2: 57.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17_21902",
    x1: 47.5191,
    y1: 22.9226,
    x2: 47.5191,
    y2: 57.0624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17_21902",
    x1: 41.0088,
    y1: 43.936,
    x2: 41.0088,
    y2: 49.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17_21902",
    x1: 40.9902,
    y1: 30.8955,
    x2: 40.9902,
    y2: 36.0624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5004"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.412427385087b0ae5e81aca3e297b044.svg";
export { ForwardRef as ReactComponent };